import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ProgressSpinnerService } from './progress-spinner.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class TokenExpiredInterceptor implements HttpInterceptor {

  constructor(private router: Router,
              private readonly toastrService: ToastrService,
              private readonly modalService: BsModalService,
              private readonly progressSpinnerService: ProgressSpinnerService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(catchError((err: HttpErrorResponse) => {
        this.progressSpinnerService.decrease();
        if (err.status === 498 || err.status === 401) {
          this.modalService.hide(1);
          this.toastrService.error(err.error.message)
          localStorage.removeItem('currentUser');
          this.router.navigateByUrl('login');
        }
        return throwError(err);
      }));
  }
}
